export function getIdSuffix (id) {
  return id?.split('-').slice(-1);
}
